export const formattedDatePp = (date, format = "MM/DD/YYYY") => {
  // "YYYY-MM-DD"
  if (!date) {
    return "";
  }
  const momentDate = moment(date).format(format);
  return moment(momentDate).isValid() ? momentDate : "";
};

export function formatPhoneNumber(phoneNumber) {
  if (!phoneNumber) {
    return "";
  }
  // Ensure the input is a string
  const cleanNumber = phoneNumber.toString().replace(/\D/g, ""); // Remove non-numeric characters

  // Format the phone number
  const formatted = `(${cleanNumber.slice(0, 3)}) ${cleanNumber.slice(
    3,
    6
  )}-${cleanNumber.slice(6)}`;

  return formatted;
}

export function getCurrentEpochTime() {
  const currentEpochMillis = Date.now();
  const currentEpochSeconds = Math.floor(currentEpochMillis / 1000);
  return {
    milliseconds: currentEpochMillis,
    seconds: currentEpochSeconds,
  };
}

export function parseResponse(res) {
  var response = null,
    data = null,
    meta = null,
    msg = "",
    code = -1;
  if (res.response) {
    response = res.response;
  } else if (res.data && res.data.response) {
    response = res.data.response;
  } else if (res.data && res.data.data) {
    response = res.data;
  } else if (res.isSuccess && res.data) {
    response = res;
    response.code = 0;
  }
  code = response?.code;
  msg = response?.msg || "";
  if (response?.code == 0 && response?.data) {
    data = response?.data || null;
    meta = response?.meta || null;
  }
  return { data, meta, msg, code };
}

export const checkValueNotNull = (value) => {
  if (value === null || value === undefined || value === "" || value === "null" || value === "undefined" || value === "NaN" || value === NaN) {
    return false;
  }
  return true;
};

const validateIPAddress = (ip) => {
  const ipParts = ip.split(".");
  if (ipParts.length !== 4) {
    console.log("Error: Invalid IP address format");
    return false;
  }

  for (const part of ipParts) {
    const num = parseInt(part, 10);
    if (isNaN(num) || num < 0 || num > 255) {
      console.log("Error: IP address octet out of range (0-255)");
      return false;
    }
  }

  // Log IP class
  const firstOctet = parseInt(ipParts[0], 10);
  if (firstOctet >= 0 && firstOctet <= 127) {
    console.log("IP Class: A");
  } else if (firstOctet >= 128 && firstOctet <= 191) {
    console.log("IP Class: B");
  } else if (firstOctet >= 192 && firstOctet <= 223) {
    console.log("IP Class: C");
  } else {
    console.log("Error: IP address is not Class A, B, or C");
    return false;
  }

  return true; // Valid IP
};

export const validateIPInput = (value) => {
  if (!value) {
    console.log("Error: IP address is empty");
    return "Invalid IP address";
  }

  if (value.length > 15) {
    console.log("Error: IP address exceeds 15 characters");
    return "Invalid IP address";
  }

  const singleIPRegex = /^[0-9.]+$/; // For single IP
  const rangeIPRegex = /^[0-9.\-]+$/; // For IP range
  if (!singleIPRegex.test(value) && !rangeIPRegex.test(value)) {
    console.log("Error: Invalid characters in IP address");
    return "Invalid IP address";
  }

  // Check if it's a single IP or a range
  const isRange = value.includes("-");

  // Validate single IP address
  if (!isRange) {
    if (!validateIPAddress(value)) {
      return "Invalid IP address";
    }
    return true;
  }

  // Validate IP address range
  if (isRange) {
    const [startIP, endIP] = value.split("-");

    // Validate start IP
    if (!validateIPAddress(startIP)) {
      return "Invalid IP address";
    }

    // Validate end IP
    if (!validateIPAddress(endIP)) {
      return "Invalid IP address";
    }

    // Ensure the start IP is less than or equal to the end IP
    const startParts = startIP.split(".");
    const endParts = endIP.split(".");
    const startIPNum = startParts.map((part) => parseInt(part, 10)).join("");
    const endIPNum = endParts.map((part) => parseInt(part, 10)).join("");
    if (startIPNum > endIPNum) {
      console.log("Error: Start IP must be less than or equal to End IP");
      return "Invalid IP address";
    }

    return true; // Valid IP range
  }

  return true; // Default return
};